
import Copyright from "../../../assets/filled/Copyright.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CopyrightIcon({ className, dataTestid = "CopyrightIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Copyright data-testid={dataTestid} className={classes} {...rest} />
  );
}
